import React, { useState, useEffect } from "react";
import { collection, getDocs, doc, onSnapshot } from "firebase/firestore";
import { db } from "./Firebase";
import styled, { keyframes, css } from 'styled-components';

const ContenedorDiv = styled.div`
  margin: 0px 1.5rem 25px 1.5em;
`;
const CuadroUsuariosDiv = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 10px;
  @media only screen and (min-width: 320px) and (max-width: 768px){
    grid-template-columns: repeat(1, 1fr);
  }
`;
const UsuarioDiv = styled.div`
  padding: 10px;
  border: 1px solid #ccc;
  background-color: rgba(255, 255, 255, 0.4);
`;
const EstiloButton = styled.button`
  padding: 5px 12px 5px 12px;
  background-color: rgba(255, 255, 255, 0.4);
  color: black;
  border: 1px solid #ccc;
  border-radius: 2px;
  margin-bottom: 10px;
  &:hover {
    color: white;
    background-color: rgb(41, 41, 41);
    transition: 0.3s;
  }
`;
const pulsate = keyframes`
  0% { opacity: 1; }
  50% { opacity: 0.5; }
  100% { opacity: 1; }
`;
const PuntoVerde = styled.div`
  background-color: ${props => props.$active ? '#39ff14' : 'gray'}; /* verde fluorescente */
  height: 20px;
  width: 20px;
  border-radius: 50%;
  margin-top: 10px;
  animation: ${props => props.$active ? css`${pulsate} 2s infinite` : 'none'};
`;

const ListarUsuarios = () => {
  const [usuarios, setUsuarios] = useState([]);
  const [conexiones, setConexiones] = useState({});
  const [actualizarDatos, setActualizarDatos] = useState(false);
  const [error, setError] = useState(null); // Nuevo estado para manejar errores

  useEffect(() => {
    const cargarUsuarios = async () => {
      const usuariosRef = collection(db, "users");
      try {
        const querySnapshot = await getDocs(usuariosRef);
        const usuariosData = [];
        querySnapshot.forEach((doc) => {
          const userData = { id: doc.id, ...doc.data() };
          usuariosData.push(userData);
        });
        setUsuarios(usuariosData);
        setActualizarDatos(false);
      } catch (error) {
        setError("Error al obtener la lista de usuarios"); // Actualizar el estado de error
      }
    };

    cargarUsuarios();

    if (actualizarDatos) {
      cargarUsuarios();
    }
  }, [actualizarDatos]);

  useEffect(() => {
    const unsubscribes = []; // Almacena las funciones de cancelación de suscripción

    // Escuchar cambios en la conexión en tiempo real
    usuarios.forEach((usuario) => {
      const userDocRef = doc(db, 'users', usuario.id);
      const unsubscribe = onSnapshot(userDocRef, (doc) => {
        if (doc.exists()) {
          setConexiones((prevState) => ({ ...prevState, [usuario.id]: doc.data().state === 'online' }));
        } else {
          setConexiones((prevState) => ({ ...prevState, [usuario.id]: false }));
        }
      });

      unsubscribes.push(unsubscribe); // Agrega la función de cancelación de suscripción al array
    });

    // Devuelve una función de limpieza que cancela todas las suscripciones cuando el componente se desmonta
    return () => {
      unsubscribes.forEach((unsubscribe) => unsubscribe());
    };
  }, [usuarios]); // Dependencia actualizada

  return (
    <ContenedorDiv>
      <h4>Usuarios activos</h4>
      <EstiloButton onClick={() => setActualizarDatos(true)}>Actualizar Datos</EstiloButton>
      {error && <div>Error: {error}</div>} {/* Muestra el mensaje de error si existe */}
      <CuadroUsuariosDiv>
        {usuarios.map((usuario) => (
          <UsuarioDiv key={usuario.id}>
            <div>
              <strong>Nombre:</strong> {usuario.nombre}
            </div>
            <div>
              <strong>Apellido:</strong> {usuario.apellido}
            </div>
            <div>
              <strong>Correo:</strong> {usuario.correo}
            </div>
            <div>
              <strong>Perfil:</strong> {usuario.perfil}
            </div>
            <PuntoVerde $active={conexiones[usuario.id]}></PuntoVerde>
            <div>
              <strong>Conexiones:</strong> {usuario.connections}
            </div>
          </UsuarioDiv>
        ))}
      </CuadroUsuariosDiv>
    </ContenedorDiv>
  );
};

export default ListarUsuarios;